import Logo from "../../../asset/youthpluswhite.png";
import { Link } from "react-router-dom";
import "./Joblayout.css";

export default function JobsHeader({ children }) {
  const hasToggle = Boolean(children);
  return (
    <div className={`job-header ${!hasToggle ? "no-toggle" : ""}`}>
      <div className="job-header-left">
        {/* Toggle button will appear here if passed */}
        {children}
      </div>
      <Link to="/jobs/job-admin" className="header-link">
        <img src={Logo} alt="logo" className="header-logo" />
      </Link>
      <div className="profile-box"></div>
    </div>
  );
}
